export function formatCoordinates(latitude, longitude) {
	const lat = Number(latitude);
	const lng = Number(longitude);
	if (!Number.isFinite(lat) || !Number.isFinite(lng)) return "";
	return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
}

export function buildGoogleMapsLink(latitude, longitude) {
	const lat = Number(latitude);
	const lng = Number(longitude);
	if (!Number.isFinite(lat) || !Number.isFinite(lng)) return "";
	return `https://www.google.com/maps?q=${lat},${lng}&z=17&hl=pt-BR`;
}

/** Mapa estático gratuito (sem API key). */
export function buildStaticMapUrl(latitude, longitude, options = {}) {
	const lat = Number(latitude);
	const lng = Number(longitude);
	if (!Number.isFinite(lat) || !Number.isFinite(lng)) return "";

	const width = options.width || 320;
	const height = options.height || 160;
	const zoom = options.zoom || 16;

	return (
		"https://staticmap.openstreetmap.de/staticmap.php?" +
		`center=${lat},${lng}&zoom=${zoom}&size=${width}x${height}` +
		`&markers=${lat},${lng},red-pushpin`
	);
}

/** Evita exibir base64 inválido (ex.: HTML de erro do Google Maps). */
export function normalizeLocationImageSrc(raw) {
	if (!raw) return null;
	const value = String(raw).trim();
	if (!value) return null;

	if (value.startsWith("data:image/")) return value;

	// JPEG / PNG / GIF / WebP em base64
	if (/^(?:\/9j\/|iVBORw0KGgo|R0lGOD|UklGR)/.test(value)) {
		const mime = value.startsWith("/9j/") ? "jpeg" : "png";
		return `data:image/${mime};base64,${value}`;
	}

	return null;
}
